import type { CSSProperties } from "react";

/**
 * Shared inline style tokens for the quiz creator surfaces.
 */

export const pageShell: CSSProperties = {
  maxWidth: "62rem",
  margin: "0 auto",
  padding: "2.5rem 1.5rem 5rem",
  width: "100%",
  minWidth: 0,
};

export const accentRule: CSSProperties = {
  width: "3rem",
  height: "4px",
  background: "var(--brand)",
  border: "none",
  margin: "0 0 1.25rem",
  borderRadius: "2px",
};

export const surface: CSSProperties = {
  background: "var(--surface)",
  borderRadius: "var(--radius-md)",
  border: "1px solid var(--border)",
};

export const primaryButton: CSSProperties = {
  padding: "0.75rem 1.25rem",
  fontSize: "1rem",
  fontWeight: 700,
  cursor: "pointer",
  borderRadius: "var(--radius-md)",
  background: "var(--brand)",
  color: "#fff",
  border: "none",
  lineHeight: 1.2,
  minHeight: "44px",
};

export const ghostButton: CSSProperties = {
  padding: "0.6rem 1rem",
  fontSize: "0.95rem",
  fontWeight: 600,
  cursor: "pointer",
  borderRadius: "var(--radius-md)",
  background: "transparent",
  color: "var(--text)",
  border: "1.5px solid var(--border)",
  lineHeight: 1.2,
  minHeight: "44px",
};

export const dangerButton: CSSProperties = {
  padding: "0.5rem 0.85rem",
  fontSize: "0.9rem",
  fontWeight: 600,
  cursor: "pointer",
  borderRadius: "var(--radius-md)",
  background: "transparent",
  color: "var(--error)",
  border: "1.5px solid oklch(from var(--error) l c h / 0.45)",
  lineHeight: 1.2,
  minHeight: "44px",
};

export const textInput: CSSProperties = {
  padding: "0.75rem 1rem",
  fontSize: "1rem",
  borderRadius: "var(--radius-md)",
  border: "2px solid var(--border)",
  background: "var(--bg)",
  color: "var(--text)",
  width: "100%",
  minWidth: 0,
  fontFamily: "inherit",
  outline: "none",
};

export const badge = (isPublished: boolean): CSSProperties => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.4rem",
  padding: "0.2rem 0.65rem",
  borderRadius: "999px",
  fontSize: "0.78rem",
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  background: isPublished ? "var(--success-lt)" : "var(--bg-deep)",
  color: isPublished ? "var(--success)" : "var(--text-mid)",
});

export const errorText: CSSProperties = {
  color: "var(--error)",
  margin: 0,
  fontWeight: 500,
};
